<style lang="less">
    .img-star {
        color: #f56c6c;
        margin: 12px -76px 0px 40px;
    }
    .hide .el-upload--picture-card {
        display: none;
    }
</style>

<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
            </div>
            <div class="detail-content-body-div flex-1">
                <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" label-width="120px" class="detail-form">
                    <div class="flex detail-form-parent-div">
                        <div class="flex-1">
                            <el-form-item label="所属app" prop="">
                                <el-select class="full-width" v-model="detailForm.belongApp" size="small" disabled>
                                    <el-option v-for="item in applist" :label="item.configName" :value="item.configVal"
                                               :key="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="消息类型" prop="messageType">
                                <el-select class="full-width" size="small" v-model="detailForm.messageType" @change="handleChangemessageType" clearable>
                                    <el-option label="告警类" value="01"></el-option>
                                    <el-option label="故障类" value="02"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="消息名称" prop="messageStatus">
                                <el-select class="full-width" size="small" v-model="detailForm.messageStatus" @change="handleChangeMessageStatus" clearable>
                                    <template v-if="detailForm.messageType === '01'">
                                        <el-option label="接地故障" value="06"></el-option>
                                    </template>
                                    <template v-if="detailForm.messageType === '02'">
                                        <el-option label="急停按下" value="00"></el-option>
                                        <el-option label="漏电故障" value="01"></el-option>
                                        <el-option label="CP故障" value="02"></el-option>
                                        <el-option label="过压故障" value="03"></el-option>
                                        <el-option label="欠压故障" value="04"></el-option>
                                        <el-option label="过流故障" value="05"></el-option>
                                        <el-option label="急停芯片故障" value="07"></el-option>
                                        <el-option label="短路故障" value="08"></el-option>
                                        <el-option label="过温故障" value="09"></el-option>
                                        <el-option label="漏电模块自检故障" value="10"></el-option>
                                        <el-option label="继电器黏连故障" value="11"></el-option>
                                        <el-option label="车枪连接异常" value="12"></el-option>
                                        <el-option label="三相不完整" value="13"></el-option>
                                    </template>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="消息文案" prop="messageRemark">
                                <el-input v-model="detailForm.messageRemark" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="发送机制" prop="sendStatus">
                                <el-select class="full-width" size="small" v-model="detailForm.sendStatus" @change="handleChangesendStatus" clearable>
                                    <el-option label="七天一次" value="01"></el-option>
                                    <el-option label="一天一次" value="02"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="启用状态">
                                <el-switch v-model="detailForm.invokeFlag" active-color="#BB87F3" inactive-color="#dcdfe6">
                                </el-switch>
                            </el-form-item>
                        </div>
                        <div class="flex-1"></div>
                    </div>
                </el-form>
            </div>
            <div class="detail-content-footer-div">
                <button class="common-bg-button" @click="submitForm('detailForm')">提 交</button>
                <button class="common-empty-button" @click="resetForm">取 消</button>
            </div>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config'
    export default {
        data() {
            return {
                pageConfig,
                editFlag: false,
                pageTitle: '消息详情',
                // 默认值设置
                detailForm: {
                    belongApp: '挚达',
                    messageType: '',
                    messageStatus: '',
                    messageRemark: '',
                    sendStatus: '',
                    invokeFlag: false,
                },
                image: [],//图片储存
                dialogVisible: false,//图片弹窗
                dialogImageUrl: null,//图片地址
                picPath: null,//图片file文件
                hideUpload: false,//上传图片按钮
                applist: [],//应用app列表
            }
        },
        methods: {
            //判断是否为编辑模式,
            init() {
                if (this.$route.query.editId) {
                    this.editFlag = true
                    this.detailForm = this.$store.state.bannerObj;
                }
            },
            //获取app 列表
            getFormInfo() {
                let _ = this
                _.$H.post(_, _.$A.config.list, { configType: '213' }).then((res) => {
                    _.applist = res.data.data
                })
            },
            //上传图片
            toUploadImg(param) {
                this.picPath = param.file
                this.hideUpload = true
            },
            //删除图片
            handleImgRemove(file) {
                this.picPath = null
                this.image = []
                this.hideUpload = false
            },
            //查看图片大图
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url
                this.dialogVisible = true
            },
            //图片大小限制
            beforeAvatarUpload(file) {
                const isLt200K = file.size / 1024 / 1024 < 1

                if (!isLt200K) {
                    this.$U.error('上传广告图片大小不能超过 1MB!')
                }
                return isLt200K
            },
            handleChangeMessageStatus(val){
                let _ = this;
                if(val === '00') _.detailForm.messageStatusName = '急停按下'
                if(val === '01') _.detailForm.messageStatusName = '漏电故障'
                if(val === '02') _.detailForm.messageStatusName = 'CP故障'
                if(val === '03') _.detailForm.messageStatusName = '过压故障'
                if(val === '04') _.detailForm.messageStatusName = '欠压故障'
                if(val === '05') _.detailForm.messageStatusName = '过流故障'
                if(val === '06') _.detailForm.messageStatusName = '接地故障'
                if(val === '07') _.detailForm.messageStatusName = '急停芯片故障'
                if(val === '08') _.detailForm.messageStatusName = '短路故障'
                if(val === '09') _.detailForm.messageStatusName = '过温故障'
                if(val === '10') _.detailForm.messageStatusName = '漏电模块自检故障'
                if(val === '11') _.detailForm.messageStatusName = '继电器黏连故障'
                if(val === '12') _.detailForm.messageStatusName = '车枪连接异常'
                if(val === '13') _.detailForm.messageStatusName = '三相不完整'
            },
            handleChangemessageType(val){
                let _ = this;
                if(val === '01') _.detailForm.messageTypeName = '告警类';
                if(val === '02') _.detailForm.messageTypeName = '故障类';
            },
            handleChangesendStatus(val){
                let _ = this;
                if(val === '01') _.detailForm.sendStatusName = '七天一次';
                if(val === '02') _.detailForm.sendStatusName = '一天一次';
            },
            // 表单提交
            submitForm(formName) {
                let _ = this;
                _.detailForm.corpNo = _.$store.state.corpNo;
                if(_.detailForm.invokeFlag === true){
                    _.detailForm.invokeFlag = 'Y'
                }else if(_.detailForm.invokeFlag === false){
                    _.detailForm.invokeFlag = 'N'
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(_.$route.query.editId){
                            // 编辑
                            _.$S.submitForm(_, _.$A.digitization.pileMessageEdit, false, _.detailForm, pageConfig.listRouter)
                        }else {
                            // 新增
                            _.$S.submitForm(_, _.$A.digitization.pileMessageAdd, _.editFlag, _.detailForm, pageConfig.listRouter)
                        }
                    }
                })
            },
            // 取消
            resetForm() {
                this.$router.push({
                    name: pageConfig.listRouter,
                })
            },
        },
        mounted() {
            this.init()
            this.getFormInfo()
        },
    }
</script>
